import {
  GroupPostAttributesContentType,
  GroupPostAttributesType,
  PostEditorState,
  PostGroupsType
} from '../../../models/post-editor';
import { ImmutabilityContext } from '../states/effects/customImmutabilityContext';
import { InitialPostEditorState } from '../states/initial';
import { PostMultiMediaAttachMode, PostSource } from '../../../models/graphql';

const getInitialContent = (
  content: GroupPostAttributesContentType,
  varyMedia: null | PostMultiMediaAttachMode
): GroupPostAttributesContentType => {
  const { update: updateImmutable } = ImmutabilityContext;
  const initialState = InitialPostEditorState();
  const initialGroupContent = initialState.postGroups[0].groupPostAttributes.content;
  return updateImmutable(initialGroupContent, {
    postFeedType: { $set: content.postFeedType },
    publishMethod: { $set: content.publishMethod },
    varyMedia: { $set: varyMedia }
  });
};
export const mapAddAnotherFromCreate = (
  state: PostEditorState,
  varyMedia: null | PostMultiMediaAttachMode
): PostEditorState => {
  const { update: updateImmutable } = ImmutabilityContext;
  return updateImmutable(state, {
    loading: { $set: false },
    shouldValidate: { $set: false },
    isValid: { $set: undefined },
    postGroups: (groups: PostGroupsType[]) =>
      groups.map(group => {
        return updateImmutable<PostGroupsType>(group, {
          activeCustomizeIndex: { $set: null },
          groupPostAttributes: {
            content: {
              $apply: current => getInitialContent(current, varyMedia)
            },
            postSource: { $set: PostSource.ADD_ANOTHER }
          },
          posts: (posts: GroupPostAttributesType[]) =>
            posts.map(post =>
              updateImmutable<GroupPostAttributesType>(post, {
                content: {
                  $apply: current => getInitialContent(current, varyMedia)
                },
                postSource: { $set: PostSource.ADD_ANOTHER }
              })
            )
        });
      })
  });
};
